import { Close } from '@mui/icons-material';
import {
  Button, Dialog, IconButton, useMediaQuery, useTheme,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useState } from 'react';
import { BUTTON_COLORS, VARIANTS } from 'shared/constants';
import ZoneDataGrid from 'features/networking/complex/ZoneDataGrid';

/**
 * @param {Object} complex - Complex object containing name and buildings
 * @param {Function} setDefault - Callback function to set default zone for buildings
 * @param {Object} state - Zone state configuration (passed via ...rest)
 */
export default function ZoneEditDialog({ complex, setDefault, ...rest }) {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { name, buildings } = complex;

  const handleSave = async (rows) => {
    await setDefault(rows).then(() => {
      setIsOpen(false);
    });
  };

  return (
    <>
      <Button
        variant={VARIANTS.outlined}
        color={BUTTON_COLORS.primary}
        onClick={() => setIsOpen(true)}
        disabled={!buildings}
      >
        Buildings
      </Button>
      {buildings && (
        <Dialog
          open={isOpen}
          keepMounted
          fullWidth
          maxWidth="lg"
          fullScreen={fullScreen}
        >
          <DialogTitle>
            {`${name} Complex Zone Configuration`}
            <IconButton
              onClick={() => setIsOpen(false)}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <ZoneDataGrid
              buildings={buildings}
              onSave={handleSave}
              {...rest}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
